import React from "react";
import PropTypes from "prop-types";
import {
  Map as MapIcon,
  Place as PlaceIcon,
  School as TrainingIcon,
  Help as HelpIcon,
  ChevronRight
} from "@material-ui/icons";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import Logo from "../../../Logo";
import LinkMenuItem from "../../components/LinkMenuItem";
import {TrainingContext} from "../../../../contexts/training";

import "./style.scss";

export default class MainMenu extends React.Component {
  getPlacePath(params) {
    const {facilityId, buildingId, floorId, markerId} = params;
    let placePath = "";
    if (facilityId) {
      const buildingPart = buildingId ? `/buildings/${buildingId}` : "";
      const floorPart = floorId ? `/floors/${floorId}` : "";
      const markerPart = markerId ? `/markers/${markerId}` : "";
      placePath = facilityId + buildingPart + floorPart + markerPart;
    }
    return placePath;
  }
  render() {
    const {match, currentUser, onClose} = this.props;
    const {permissions} = currentUser;
    const {facilityId} = match.params;
    const placePath = this.getPlacePath(match.params);
    return (
      <TrainingContext.Consumer>
        {({onToggleTrainingModal}) => (
          <React.Fragment>
            <List>
              <LinkMenuItem
                to={`/map/${placePath}`}
                onClick={onClose}
                selected={match.url.startsWith("/map")}
                primary={<p className="menuItemText">Map</p>}
                iconLeft={<MapIcon />}
              />
              {permissions.edit.resources && (
                <React.Fragment>
                  <LinkMenuItem
                    to={`/marker-settings?facilityId=${facilityId}`}
                    selected={match.url.startsWith("/marker-types")}
                    primary={<p className="menuItemText">Marker Settings</p>}
                    iconLeft={<PlaceIcon />}
                    iconRight={<ChevronRight />}
                  />
                  <Divider />
                </React.Fragment>
              )}
              <LinkMenuItem
                onClick={onToggleTrainingModal}
                primary={<p className="menuItemText">Training & Tutorials</p>}
                iconLeft={<TrainingIcon />}
              />
              <Divider />
              <LinkMenuItem
                href={"https://mapplug.zendesk.com"}
                target="_blank"
                rel="noopener noreferrer"
                primary={<p className="menuItemText">Help</p>}
                iconLeft={<HelpIcon />}
              />
            </List>
            <Logo className="mobileOnlyLogo" width="140" />
          </React.Fragment>
        )}
      </TrainingContext.Consumer>
    );
  }
}

MainMenu.propTypes = {
  currentUser: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Sidebar/Menus/MainMenu/index.jsx